<svelte:options accessors />

<script context="module" lang="ts">
	export let count = 0;
	export type TextInputType = 'email' | 'password' | 'search' | 'tel' | 'text' | 'url';
</script>

<script lang="ts">
	export const InstanceID = count;
	count += 1;
	import FormGroup from '../sub_components/FormGroup.svelte';
	import { SetValidator, type TValidators } from '$lib/validator';
	import { onMount } from 'svelte';
	import type { PhoneConfig, TextInputConfig } from '$lib/config';
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();
	import * as Store from '$lib/client/store';
	import { REST } from '$lib/client/conn';
	import { getDataFromMask, getInputMask } from '../mask';
	import type { TAutocomplete, TAutocompleteLvl2 } from './types';
	export let Config: TextInputConfig;
	export let InsideTitle: null | string = null;
	export let AutoComplete: null | TAutocomplete = null;
	export let AutoCompleteLvl2: null | TAutocompleteLvl2 = null;
	export let ReadOnly: boolean = false;
	export let Disabled: boolean = false;
	export let SaveData: boolean = true;
	let Shown = Config.Shown;
	let inputMask: string | null = null;
	import { MaskHandler } from '$lib/client/mask';
	import { KTIForm, type ServerDataValidation } from '../form';
	import { adjustNotchWidth } from '../utility';
	import { browser } from '$app/environment';
	let maskHandler: MaskHandler;
	//export let OnChange = () => {};
	//export let OnInput = () => {};

	export let ErrorMsg = Config.Required ? 'Required field' : 'Invalid value';
	let validator: null | TValidators = null;
	export let Valid = false;
	export let Value: string = '';
	let labelEl: HTMLLabelElement;
	let notchMiddleEl: HTMLDivElement;
	const isPhoneComp = Config.Mask == '(999) 999-9999';
	const phoneConfig = Config as unknown as PhoneConfig;
	let requiresPhoneCheck = false;
	if (isPhoneComp) {
		requiresPhoneCheck =
			phoneConfig.Required &&
			(phoneConfig.UseForParticipationCheck === true ||
				phoneConfig.UseForProductCheck === true ||
				phoneConfig.UseForSubmissionDupCheck === true ||
				phoneConfig.UseForInstanceCheck === true);
	}
	let serverValidation: ServerDataValidation | null = requiresPhoneCheck
		? KTIForm.addServerValidation('phone')
		: null;

	export function show() {
		Config.Shown = true;
		Shown = true;
	}

	export function hide() {
		Config.Shown = false;
		Shown = false;
	}

	export function formatValue(value: string, mask: string) {
		let outputStr = '';
		let val_index = 0;
		for (let char of mask) {
			if (char == '9' && /\d/.test(value[val_index])) {
				outputStr += value[val_index];
				val_index++;
			} else if (char == 'a' && /[a-zA-Z]/.test(value[val_index])) {
				outputStr += value[val_index];
				val_index++;
			} else if (char == '*' && /[a-zA-Z0-9]/.test(value[val_index])) {
				outputStr += value[val_index];
				val_index++;
			} else {
				outputStr += char;
			}
		}
		return outputStr;
	}

	export function setValue(value: string) {
		if (value === null) {
			Value = '';
			return;
		}
		console.log('TextInput Setting value', value, value.length, isPhoneComp, Config.Type);
		//Convert incoming value into mask format
		if (Config.Mask) {
			Value = formatValue(value, Config.Mask);
			return;
		}
		Value = value;
	}
	export function doPhoneServerValidation() {
		if (!serverValidation) {
			return;
		}
		if (!Config.Mask) {
			console.log('Phone: No mask');
			return;
		}
		const phoneValue = getDataFromMask(Config.Mask, Value);

		if (serverValidation && phoneValue) {
			//Check if phone is duplicate or reject
			if (serverValidation.value && serverValidation.value.phone == phoneValue) {
				return;
			}
			serverValidation.validate_value({ phone: phoneValue });
		}
	}

	if (Config.Mask) {
		inputMask = getInputMask(Config.Mask);
	}

	let compOutlineEl: HTMLElement;
	let inputEl: HTMLInputElement;
	let ErrorEl: HTMLElement;
	let maskObj: any;
	if (Config.Type == 'TextInput') {
		InsideTitle = '';
	}
	onMount(async () => {
		if (Config.Mask) {
			maskHandler = new MaskHandler(Config.Mask, inputEl);
		}
		if (Config.Validator) {
			validator = SetValidator(
				Config.Validator,
				Config.Required,
				inputEl,
				setValid,
				setInvalid,
				setNuetral
			);
		}
		if (Config.Mask) {
			// maskObj = new Inputmask(inputEl, Mask);
			// inputEl.addEventListener('input.mdb.inputmask', () => {
			// 	alert('Mask input input!');
			// });
			// inputEl.addEventListener('complete.mdb.inputmask', () => {
			// 	alert('Mask input completed!');
			// });
			// window.maskOBj = maskObj;
			//console.log('maskObj', maskObj);
		}
		// createEventHandler(inputEl, 'input.mdb.inputmask', (e) => {
		// 	console.log('inputmask event', e);
		// 	alert('sts');
		// });
		if (labelEl && notchMiddleEl && browser) {
			console.log('Calling adjustNotchWidth');
			adjustNotchWidth(labelEl, notchMiddleEl);
		}
	});
	export function appendData(formData: FormData) {
		if (!SaveData) {
			formData.append('dont_save_columns', Config.DBCol);
			return;
		}
		if (Config.Mask) {
			formData.append(Config.DBCol, getDataFromMask(Config.Mask, inputEl.value)); // Append the formatted input to the FormData
		} else {
			formData.append(Config.DBCol, inputEl.value);
		}
	}
	let touched = false;
	function validVal(char: string, maskChar: string) {
		if (maskChar == 'a' && /[a-zA-Z]/.test(char)) {
			return true;
		} else if (maskChar == '9' && /\d/.test(char)) {
			return true;
		} else if (maskChar == '*' && /[a-zA-Z0-9]/.test(char)) {
			return true;
		}
		return false;
	}
	// function getUserVal(
	// 	e: InputEvent,
	// 	inputVal: string,
	// 	mask: string,
	// 	el: HTMLInputElement = inputEl
	// ) {
	// 	if (!Config.Mask) {
	// 		return;
	// 	}
	// 	let caretPos = inputEl.selectionStart || 0;

	// 	// Detect backspace event
	// 	if (
	// 		e.inputType === 'deleteContentBackward' &&
	// 		caretPos > 0 &&
	// 		!/[a9*]/.test(Config.Mask[caretPos])
	// 	) {
	// 		// Move the caret backward to the closest user-enterable position ('a', '*', or '9')
	// 		for (let i = caretPos - 1; i >= 0; i--) {
	// 			if (/[a9*]/.test(mask[i])) {
	// 				caretPos = i;
	// 				break;
	// 			}
	// 		}
	// 		// Remove the user-entered character at the new caretPos, if any
	// 		if (/[a9*]/.test(mask[caretPos])) {
	// 			inputVal = inputVal.substring(0, caretPos) + inputVal.substring(caretPos + 1);
	// 		}
	// 	}
	// 	if (el.value.length > mask.length && e.data && e.data.length == 1) {
	// 		//if caret position is after a valid mask element than
	// 		//replace rather than push values
	// 		//if (/[a9*]/.test(mask[caretPos])) {
	// 		//Erase the character at the caret position
	// 		//el.value =
	// 		inputVal = el.value.substring(0, caretPos) + el.value.substring(caretPos + 1);
	// 		//caretPos++;
	// 		// }
	// 		// else {
	// 		// 	//get next mask location
	// 		// 	let i = caretPos;
	// 		// 	for (; i < mask.length; i++) {
	// 		// 		if (/[^a9*]/.test(mask[i])) {
	// 		// 			break;
	// 		// 		}
	// 		// 	}
	// 		// 	inputVal = el.value.substring(0, i) + el.value.substring(i + 1);
	// 		// }
	// 	}
	// 	//Save caret position
	// 	const caretAtEnd = caretPos == inputVal.length;
	// 	const addedTextLength = e.data?.length || 1;
	// 	let outputStr = '';
	// 	let i = 0;
	// 	let matchedAValue = false;
	// 	let addedCharsAfterCaret = 0;
	// 	let filledOut = false;

	// 	//On first input insert any beginning characters from the mask
	// 	for (; i < mask.length; i++) {
	// 		if (/[^a9*]/.test(mask[i]) && inputVal[i] != mask[i] && mask[i] != inputVal[0]) {
	// 			outputStr += mask[i];
	// 			addedCharsAfterCaret++;
	// 			continue;
	// 		}
	// 		break;
	// 	}

	// 	// Iterate over each character in the mask and match it with the corresponding input character
	// 	let inputIndex = 0;
	// 	let setCaretPos = false;
	// 	for (; i < mask.length; i++) {
	// 		const maskChar = mask[i];
	// 		const inputChar = inputVal[inputIndex];
	// 		// console.log(
	// 		// 	el.value.length,
	// 		// 	mask.length,
	// 		// 	e.data?.length,
	// 		// 	maskChar == inputChar,
	// 		// 	maskChar,
	// 		// 	inputChar,
	// 		// 	/[^a9*]/.test(maskChar)
	// 		// );
	// 		if (/[^a9*]/.test(maskChar)) {
	// 			if (maskChar == inputChar) {
	// 				outputStr += inputChar;
	// 				if (i >= caretPos) {
	// 					addedCharsAfterCaret++;
	// 				}
	// 				inputIndex++;
	// 				continue;
	// 			}
	// 			// else if (el.value.length > mask.length && e.data?.length == 1) {
	// 			// 	inputVal = el.value.slice(0, inputIndex) + el.value.slice(inputIndex + 1);
	// 			// 	console.log('el.value', el.value);
	// 			// 	continue;
	// 			// }
	// 		}
	// 		if (inputIndex >= inputVal.length && inputMask) {
	// 			if (!setCaretPos) {
	// 				if (inputMask[i] == '_') {
	// 					caretPos = i;
	// 					setCaretPos = true;
	// 				}
	// 			}
	// 			outputStr += inputMask[i];
	// 			continue;
	// 		}

	// 		if (maskChar === 'a' && /[a-zA-Z]/.test(inputChar)) {
	// 			outputStr += inputChar;
	// 			matchedAValue = true;
	// 			inputIndex++;
	// 		} else if (maskChar === '9' && /\d/.test(inputChar)) {
	// 			outputStr += inputChar;
	// 			matchedAValue = true;
	// 			inputIndex++;
	// 		} else if (maskChar === '*' && /[a-zA-Z0-9]/.test(inputChar)) {
	// 			outputStr += inputChar;
	// 			matchedAValue = true;
	// 			inputIndex++;
	// 		} else if (/[^a9*]/.test(maskChar)) {
	// 			// Allow for characters like '(', ')', '-', and ' ' in the mask
	// 			// if (i >= caretPos) {
	// 			// 	//addedCharsAfterCaret++;
	// 			// }
	// 			outputStr += maskChar;
	// 		} else {
	// 			// If the input character doesn't match the mask, skip it
	// 			inputIndex++;
	// 			i--;
	// 		}
	// 		//console.log(outputStr, '-', inputChar);
	// 	}
	// 	el.value = outputStr;
	// 	if (inputEl.value.length > Config.Mask.length) {
	// 		onInteract(e);
	// 	} else {
	// 		//Manage caret position
	// 		if (!/[a9*]/.test(Config.Mask[caretPos])) {
	// 			// Find the next position where Mask character is 'a', '*' or '9'
	// 			for (let i = caretPos + 1; i < Config.Mask.length; i++) {
	// 				if (/[a9*]/.test(Config.Mask[i])) {
	// 					caretPos = i;
	// 					break;
	// 				}
	// 			}
	// 		}
	// 		el.setSelectionRange(caretPos, caretPos);
	// 	}
	// 	// if (setCaretPos) {
	// 	// 	el.value = outputStr;
	// 	// 	el.setSelectionRange(caretPos, caretPos);
	// 	// } else {
	// 	// 	if (caretPos < outputStr.length && Mask && /[^a9*]/.test(Mask[caretPos])) {
	// 	// 		for (let i = caretPos; i < outputStr.length; i++) {
	// 	// 			if (Mask && /[^a9*]/.test(Mask[i])) {
	// 	// 				caretPos++;
	// 	// 			} else {
	// 	// 				break;
	// 	// 			}
	// 	// 		}
	// 	// 		el.setSelectionRange(caretPos, caretPos);
	// 	// 	}
	// 	// 	el.value = outputStr;
	// 	// }
	// 	return outputStr;
	// 	if (!matchedAValue || caretAtEnd) {
	// 		//console.log('setting caret position to end', el.value.length);
	// 		//el.setSelectionRange(el.value.length, el.value.length);
	// 		//el.selectionStart = el.selectionEnd = outputStr.length - 1;
	// 	} else if (!e.data) {
	// 		el.setSelectionRange(caretPos, caretPos);
	// 	} else if (addedTextLength >= 1) {
	// 		while (true) {
	// 			if (caretPos > mask.length - 1) {
	// 				break;
	// 			}
	// 			if (/[^a9*]/.test(mask[caretPos - 1])) {
	// 				caretPos++;
	// 			} else {
	// 				break;
	// 			}
	// 		}
	// 		console.log('addedCharsAfterCaret', addedCharsAfterCaret);
	// 		console.log('setting caret position', caretPos + addedTextLength);
	// 		el.setSelectionRange(caretPos, caretPos);
	// 	}
	// 	return outputStr;
	// }

	function onInput(e: Event) {
		const inputEvent = e as InputEvent;
		// if (Config.Mask) {
		// 	const phoneNumber = maskHandler.handleInputEvent(inputEvent); // Use the mask parameter
		// 	let maskedPhoneNumber = '';

		// 	// Handle phone numbers with or without a country code
		// 	if (phoneNumber && phoneNumber.length >= 10) {
		// 		maskedPhoneNumber = `+1 (${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(
		// 			3,
		// 			6
		// 		)}-${phoneNumber.substring(6, 10)}`;
		// 	}

		// 	//inputEl.value = phoneNumber;
		// 	// if (inputEl.selectionStart != null) {
		// 	// 	inputEl.selectionStart = caretPos + addedTextLength;
		// 	// 	inputEl.selectionEnd = caretPos + addedTextLength;
		// 	// }
		// 	console.log('maskedPhoneNumber', phoneNumber);
		// }
		console.log('inputEl.value', inputEl.value);
		if (validator == null) {
			touched = true;
			if (inputEl.value != '') {
				setNuetral();
			}
		}
	}
	function onChange(e: Event) {}

	/** */
	// function refreshInputValue() {
	//     if(!userInputMask || !Mask){return}
	//     let newValue = '';
	//     for(let i = 0; i < userInputMask.length; i++){
	//         if(userInputMask[i] == '0'){
	//             if(inputEl.value[i] != Mask[i])}{}
	//             newValue += Mask[i];
	//         }else if(inputEl.value[i]){
	//             newValue += userInputMask[i];
	//         }
	//     }
	// }
	function onClick(e: Event) {
		if (Config.Mask) {
			maskHandler.onInteract(e);
		}
		// 	if (Mask) {
		//         refreshInputValue();
		// 		inputEl.value = Mask?.replaceAll(/[a9*]/g, '_') || '';
		// 		//Set caret position to first editable character
		// 		//Get position of first a, 9, or * in mask
		// 		let caretPos = 0;
		// 		for (let i = 0; i < Mask.length; i++) {
		// 			if (/[a9*]/.test(Mask[i])) {
		// 				caretPos = i;
		// 				break;
		// 			}
		// 		}
		// 		setTimeout(() => inputEl.setSelectionRange(caretPos, caretPos), 10);
		// 	}
	}
	function onFocus(e: Event) {
		inputFocused = true;
		// if (Mask) {
		// 	refreshInputValue(e);
		// }
	}
	let inputFocused = false;
	function onBlur(e: Event) {
		if (validator == null) {
			inputFocused = false;
			if (inputEl.value == '') {
				if (Config.Required) {
					setInvalid();
				} else {
					setNuetral();
					Valid = true;
				}
			} else {
				setValid();
			}
		}
		// if (validator) {
		// 	let result = validator.Validate();
		// }
		validate();
	}
	export function setNuetral() {
		//"Bubble" the event up to the parent component
		dispatch('setNuetral');
		// if (Required) {
		// 	return;
		// }
		inputEl.classList.remove('is-valid');
		inputEl.classList.remove('is-invalid');
		ErrorEl.style.display = 'none';
		Valid = false;
	}
	export function setInvalid() {
		//"Bubble" the event up to the parent component
		dispatch('setInvalid');
		if (serverValidation) {
			serverValidation.valid = false;
		}
		Valid = false;
		inputEl.classList.add('is-invalid');
		inputEl.classList.remove('is-valid');
		if (ErrorMsg) {
			ErrorEl.style.display = 'block';
		} else {
			ErrorEl.style.display = 'none';
		}
	}
	export function setValid() {
		//"Bubble" the event up to the parent component
		dispatch('setValid');
		Valid = true;
		inputEl.classList.add('is-valid');
		inputEl.classList.remove('is-invalid');
		ErrorEl.style.display = 'none';
		//Event.trigger('addressValid');
		if (requiresPhoneCheck) {
			doPhoneServerValidation();
		}
	}
	export function focus() {
		inputEl.focus();
	}
	export async function validate() {
		console.log('Validate called', InsideTitle, Config.Title);
		Value = inputEl.value;
		if (validator == null) {
			if (inputEl.value == '') {
				if (Config.Required) {
					setInvalid();
				} else {
					setNuetral();
					Valid = true;
				}
			} else {
				setValid();
			}
		}
		if (validator) {
			let validity = validator.Validate();
			if (validity != 'neither') {
				Valid = validity;
			}
		}
		return Valid;
	}
</script>

<FormGroup {Config} style="padding-bottom: 7px;">
	<div class="col">
		{#if Config.Title}
			<div class="comp-title">{Config.Title}</div>
		{/if}
		<div class="form-outline" bind:this={compOutlineEl}>
			<input
				type="text"
				id="TextInput_{Config.DBCol}"
				class="form-control"
				class:active={Value != ''}
				maxlength={Config.MaxLength}
				name={InsideTitle ? InsideTitle : AutoComplete ? AutoComplete : ''}
				autocomplete={AutoComplete
					? AutoCompleteLvl2
						? AutoComplete + ' ' + AutoCompleteLvl2
						: AutoComplete
					: null}
				on:input={onInput}
				on:blur={onBlur}
				on:focus={onFocus}
				on:click={onClick}
				bind:this={inputEl}
				bind:value={Value}
				placeholder={Config.Mask ?? Config.Placeholder}
				class:faded_placeholder={Config.Mask ?? Config.Placeholder}
				required={Config.Required}
				disabled={Disabled}
				readonly={ReadOnly}
			/>
			<div class="form-notch">
				<div class="form-notch-leading" style="width: 9px;" />
				<div class="form-notch-middle" style="width: 0px;" bind:this={notchMiddleEl} />
				<div class="form-notch-trailing" />
			</div>
			{#if InsideTitle && !Config.Title}
				<label class="form-label" for="TextInput_{Config.DBCol}" bind:this={labelEl}
					>{InsideTitle}</label
				>
			{/if}
			{#if Config.ShowCount && inputFocused}
				<div class="form-helper">
					<div class="form-counter">{Value.length} / 100</div>
				</div>
			{/if}
			<div class="invalid-tooltip" id="TextInput_{Config.DBCol}Error" bind:this={ErrorEl}>
				{ErrorMsg}
			</div>
			<div class="msg-spacer" />
		</div>
	</div>
</FormGroup>

<style>
	.faded_placeholder::placeholder {
		opacity: 0.3;
	}
</style>
